import { useSelector } from 'react-redux';
import { Spacer } from '@vinted/web-ui';
import { ADVERTISING_URL, APP_LANDING_URL, BUSINESS_ACCOUNTS_GUIDE_URL, BUSINESS_ACCOUNTS_HOMEPAGE, FORUM_FAVOURITE_TOPICS_URL, FORUM_HOME_URL, FORUM_OWN_TOPICS_URL, HELP_BUYING_URL, HELP_CENTER_URL, HELP_SAFETY_URL, HELP_SELLING_URL, HOW_IT_WORKS_URL, INFOBOARD_URL, JOBS_URL, JOBS_URL_NEW, MAIN_NAVIGATION_ABOUT_TAB_URL, PRESS_URL } from 'constants/routes';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import useTracking from 'hooks/useTracking';
import useTranslate from 'hooks/useTranslate';
import { clickEvent } from 'libs/common/event-tracker/events';
import { getPressCenterUrl, getSustainabilityUrl } from 'libs/utils/press-center';
import { getLocale } from 'libs/utils/window';
import { getIsFeatureSwitchEnabled } from 'state/feature-switches/selectors';
import { getUser } from 'state/session/selectors';
import LinkSectionGroup from './LinkSectionGroup';
import LinkSectionItem from './LinkSectionItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

const LinksSection = _ref => {
  let {
    isBusinessInfoLinksEnabled
  } = _ref;
  const isJobsPageEnabled = useSelector(getIsFeatureSwitchEnabled('jobs_page'));
  const isForumDisabled = useSelector(getIsFeatureSwitchEnabled('disable_forum_web'));
  const isSustainabilityPageEnabled = useSelector(getIsFeatureSwitchEnabled('sustainability_page_press_center_link'));
  const isPressMenuEnabled = useSelector(getIsFeatureSwitchEnabled('press_menu'));
  const user = useSelector(getUser);
  const locale = useSelector(getLocale);
  const isPressCenterLinkEnabled = useSelector(getIsFeatureSwitchEnabled('web_press_center_link'));
  const isNewJobsUrlEnabled = useSelector(getIsFeatureSwitchEnabled('new_jobs_career_portal'));
  const shortLocale = locale.substring(0, 2);
  const pressUrl = isPressCenterLinkEnabled ? getPressCenterUrl(shortLocale) : PRESS_URL;
  const jobsUrl = isNewJobsUrlEnabled ? JOBS_URL_NEW : JOBS_URL;
  const translate = useTranslate('footer');
  const {
    track
  } = useTracking();

  function handleSustainabilityClick() {
    track(clickEvent({
      target: ClickableElement.SustainabilityPageLink,
      targetDetails: 'navigation_web'
    }));
  }

  return /*#__PURE__*/_jsxs("ul", {
    className: "main-footer__links-section",
    children: [/*#__PURE__*/_jsxs(LinkSectionGroup, {
      title: translate('company.title'),
      children: [/*#__PURE__*/_jsx(LinkSectionItem, {
        text: translate('company.items.about'),
        url: MAIN_NAVIGATION_ABOUT_TAB_URL
      }), isJobsPageEnabled && /*#__PURE__*/_jsx(LinkSectionItem, {
        text: translate('company.items.jobs'),
        url: jobsUrl
      }), isSustainabilityPageEnabled && /*#__PURE__*/_jsx(LinkSectionItem, {
        text: translate('company.items.sustainability'),
        url: getSustainabilityUrl(shortLocale),
        onClick: handleSustainabilityClick
      }), isPressMenuEnabled && /*#__PURE__*/_jsx(LinkSectionItem, {
        text: translate('company.items.press'),
        url: pressUrl
      }), /*#__PURE__*/_jsx(LinkSectionItem, {
        text: translate('company.items.advertising'),
        url: ADVERTISING_URL
      })]
    }), /*#__PURE__*/_jsxs(LinkSectionGroup, {
      title: translate('discover.title'),
      children: [/*#__PURE__*/_jsx(LinkSectionItem, {
        text: translate('discover.items.how_it_works'),
        url: HOW_IT_WORKS_URL
      }), /*#__PURE__*/_jsx(LinkSectionItem, {
        text: translate('discover.items.app'),
        url: APP_LANDING_URL
      }), /*#__PURE__*/_jsx(LinkSectionItem, {
        text: translate('discover.items.help'),
        url: HELP_CENTER_URL
      }), /*#__PURE__*/_jsx(LinkSectionItem, {
        text: translate('discover.items.infoboard'),
        url: INFOBOARD_URL
      }), isBusinessInfoLinksEnabled && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(LinkSectionItem, {
          text: translate('discover.items.pro'),
          url: BUSINESS_ACCOUNTS_HOMEPAGE
        }), /*#__PURE__*/_jsx(LinkSectionItem, {
          text: translate('discover.items.pro_guide'),
          url: BUSINESS_ACCOUNTS_GUIDE_URL
        })]
      })]
    }), /*#__PURE__*/_jsxs(LinkSectionGroup, {
      title: translate('help.title'),
      children: [/*#__PURE__*/_jsx(LinkSectionItem, {
        text: translate('help.items.centre'),
        url: HELP_CENTER_URL
      }), /*#__PURE__*/_jsx(LinkSectionItem, {
        text: translate('help.items.selling'),
        url: HELP_SELLING_URL
      }), /*#__PURE__*/_jsx(LinkSectionItem, {
        text: translate('help.items.buying'),
        url: HELP_BUYING_URL
      }), /*#__PURE__*/_jsx(LinkSectionItem, {
        text: translate('help.items.safety'),
        url: HELP_SAFETY_URL
      })]
    }), isForumDisabled ? /*#__PURE__*/_jsx(Spacer, {
      orientation: Spacer.Orientation.Vertical
    }) : /*#__PURE__*/_jsxs(LinkSectionGroup, {
      title: translate('community.title'),
      children: [/*#__PURE__*/_jsx(LinkSectionItem, {
        text: translate('community.items.forum'),
        url: FORUM_HOME_URL
      }), !!(user !== null && user !== void 0 && user.favourite_topic_count) && /*#__PURE__*/_jsx(LinkSectionItem, {
        text: translate('community.items.forum_favourite_topics'),
        url: FORUM_FAVOURITE_TOPICS_URL
      }), !!user && /*#__PURE__*/_jsx(LinkSectionItem, {
        text: translate('community.items.forum_own_topics'),
        url: FORUM_OWN_TOPICS_URL
      })]
    })]
  });
};

export default LinksSection;